import {coerceToString} from "../../../utils/coerceToString";

export function calculateFilteredDataKeys(initialRowKeys, initialRows, activeFilters) {

    if ( initialRowKeys.length === 0 || Object.keys(initialRows).length === 0 ) {
        // if there are no initial row keys or initial rows we want to return an empty array
        // as we lack sufficient data to calculate the filtered data keys.
        // Note: we do this early to save performing unneeded calculations.
        return []
    }

    let filteredDataKeys = [ ...initialRowKeys ];

    if ( activeFilters.length > 0 ) {
        // apply active filters to the data
        // a row must match at least one of the values for each field in the active filters

        filteredDataKeys = filteredDataKeys.filter(rowKey => {

            const rowData = initialRows[rowKey];

            // gives us an object where the keys are field names and the values are whether the row matched for
            // each value for that field in the active filters.
            const filterFieldMatches = {};
            activeFilters.map(activeFilter => {

                const { field, value } = activeFilter;

                if ( filterFieldMatches[field] === undefined ) {
                    filterFieldMatches[field] = [];
                }
                // we need to coerce to strings for these value comparisons because if we receive the value from
                // a form (aka: e.target.value) it will have been coerced already.
                filterFieldMatches[field].push(coerceToString(rowData[field]).toUpperCase() === coerceToString(value).toUpperCase())

            });

            // condenses the above object into an array of booleans describing whether any value matched for each field
            const filterMatches = Object.keys(filterFieldMatches).map(field => {
                const matches = filterFieldMatches[field];
                return matches.some(item => item === true);
            });

            // condenses the above array into a single boolean as to whether this row matched
            return filterMatches.every(item => item === true);
        })
    }

    return filteredDataKeys;
}
